export interface City {
    id: string;
    name: string;
}

export interface UserSkill {
    skillId: string;
    skillTitle: string;
}

export interface User {
    id: string;
    createdAt: string;
    phone: number;
    status: string;
    employmentStatus: EmploymentStatus; 
    hasActiveTasks: boolean;
    fullName?: string;
    birthDate?: string;
    city?: City;
    aboutMe?: string;
    userSkills?: UserSkill[];
    commission: number;
    isAdmin: boolean;
    avatar?: string; // Добавляем поле avatar
    personalData?: PersonalData; // Добавляем personalData
}

export interface PersonalData {
    fullName?: string;
    inn?: string;
    fnsDeviceId?: string;
    fnsUserAgent?: string;
    fnsToken?: string;
    fnsRefreshToken?: string;
    fnsRefreshTokenExpiresAt?: string;
    fnsRegistrationDate?: string;
    snils?: string;
    birthDate?: string;
}

export interface RequestUpdateAboutMeDTO {
    aboutMe?: string;
}

export interface RequestChangeUserCityDTO {
    cityId: string;
}

export interface RequestAddUserSkillsDTO {
    skillIds: string[];
}

export enum EmploymentStatus {
    Free = "Free",
    Busy = "Busy",
}
